import "../../styles/SectionFood.css"
import {getIcon, smoothScrollToId} from "../../utils/helper";

const SectionContactUs = () => {
    const handleOpenNewTab = () => {
        if(window){
            window.open('https://d-gastro24.de/order/hamirestaurant', '_blank', 'noopener,noreferrer');
        }
    };
    const handleOpenScroll = () => {
        smoothScrollToId('tisch-reservieren')
    }
    return (
        <section className="section about text-center" aria-labelledby="dish-label">
            <div className="container">
                <div className="about-content">
                    <div className="wrap-title">
                        <div className="icon-title">
                            <img src="/assets/images/badge-1.png" width="28" height="41" loading="lazy" alt="badge"
                                 className=" "/>
                        </div>
                        <div className="title">
                            <p className="label-2 section-subtitle slider-reveal">Our Story</p>
                            <div className="icon-separator">
                                {getIcon("separator")}
                            </div>
                        </div>
                    </div>
                    <h2 className="headline-1 section-title">
                        3. Das Erlebnis bei Ha Mi
                    </h2>
                    <div className="section-text">
                        <p>
                            Wir glauben, dass Kulinarik mehr ist als nur das Genießen von Speisen – sie ist eine
                            Möglichkeit, sich zu verbinden, zu teilen und Neues zu entdecken.
                        </p>
                        <p>
                            Ha Mi bietet nicht nur köstliche Gerichte, sondern auch einen Ort voller Kreativität und
                            Inspiration.
                            Wir laden Sie herzlich ein, einzigartige vietnamesische Fusionsgerichte zu erleben – wo
                            jeder Geschmack eine noch unentdeckte Geschichte erzählt.

                        </p>
                    </div>


                    <div className="wrapBtn">
                        {/*<button onClick={handleOpenNewTab}  type="button" className={`btnSecondary btn`}>*/}
                        {/*    <span className={`text text1`}>Online bestellen</span>*/}
                        {/*    <span className={`text text2`} aria-hidden="true">Online bestellen</span>*/}
                        {/*</button>*/}
                        <button onClick={handleOpenScroll} type="button" className={`btnSecondary btn`}>
                            <span className={`text text1`}>Tisch reservieren</span>
                            <span className={`text text2`} aria-hidden="true">Tisch reservieren</span>
                        </button>
                    </div>


                </div>
                <div className="special-dish-banner">
                    <img src="/assets/images/special-bei-banner.jpg" loading="lazy"
                         alt="special dish" className="img-cover"/>
                </div>
            </div>


            <img src="/assets/images/shape-4.png" width="179" height="359" loading="lazy" alt=""
                 className="shape shape-4"/>

        </section>
    )
}
export default SectionContactUs